import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { AttachmentModule } from '@ui-components/components/attachment/attachment.module';
import { IconModule } from '@ui-components/components/icon/icon.module';
import { InputFileModule } from '@ui-components/components/input-file/input-file.module';
import { PictureModule } from '@ui-components/components/picture/picture.module';

import { UnitDetailsPicturesSectionComponent } from './unit-details-pictures-section.component';

@NgModule({
  declarations: [UnitDetailsPicturesSectionComponent],
  exports: [UnitDetailsPicturesSectionComponent],
  imports: [
    CommonModule,
    IconModule,
    MatButtonModule,
    AttachmentModule,
    InputFileModule,
    ReactiveFormsModule,
    PictureModule,
    MatProgressSpinnerModule,
  ],
})
export class UnitDetailsPicturesSectionModule {}
